import { ncbData } from '../../../api';

const CITATIONS_TABLE = 'family_tree_citations_1783000000';

export async function loadFamilyTreeCitations(memorialId, memberId) {
  return ncbData('read', CITATIONS_TABLE, {
    memorial_id: String(memorialId ?? ''),
    family_member_id: String(memberId ?? ''),
  });
}

export async function createFamilyTreeCitation(citation) {
  return ncbData('create', CITATIONS_TABLE, {
    memorial_id: citation.memorial_id,
    family_member_id: citation.family_member_id,
    family_member_name: citation.family_member_name,
    source_title: citation.source_title,
    source_url: citation.source_url,
    source_type: citation.source_type,
    citation_note: citation.citation_note,
    created_at: citation.created_at,
    updated_at: citation.updated_at,
  });
}

export async function updateFamilyTreeCitation(id, citation) {
  return ncbData('update', `${CITATIONS_TABLE}/${id}`, {
    memorial_id: citation.memorial_id,
    family_member_id: citation.family_member_id,
    family_member_name: citation.family_member_name,
    source_title: citation.source_title,
    source_url: citation.source_url,
    source_type: citation.source_type,
    citation_note: citation.citation_note,
    updated_at: citation.updated_at,
  });
}

export async function deleteFamilyTreeCitation(id) {
  return ncbData('delete', `${CITATIONS_TABLE}/${id}`, {});
}